import Helper from '@ember/component/helper';
import { service, type Registry as Services } from '@ember/service';

import { formatMoney, type FormatMoneyOptions } from '@repo/design-system-kit';

type FormatMoneyHelperOptions = FormatMoneyOptions & {
  locale?: string;
};

interface FormatMoneySignature {
  Args: {
    Positional: [number];
    Named: FormatMoneyHelperOptions;
  };
  Return: string;
}

export default class FormatMoneyHelper extends Helper<FormatMoneySignature> {
  @service declare intl: Services['intl'];

  init(...args: Parameters<Helper['init']>) {
    super.init(...args);
    // @ts-expect-error - this.intl is not typed
    this.intl.onLocaleChanged(this.recompute, this);
  }

  compute([value]: [number], options: FormatMoneyHelperOptions) {
    const result = formatMoney({
      ...options,
      amount: value,
      locale: options.locale ?? this.intl.primaryLocale,
    });
    return result;
  }
}
